import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { selectTreatmentWithConfig } from '@splitsoftware/splitio-redux';

import { removeNavConfirm } from 'redux/actions/interaction';
import { initSplit } from 'redux/actions/splitAction';
import { initGetAllToken, auth0logout } from 'redux/actions/auth';
import DashboardPage from './Dashboard.page';

const mapStateToProps = state => ({
  interaction: state.interaction,
  me: state.auth.me,
  token: state.auth.token,
  auth0loading: state.auth.auth0loading,
  auth0user: state.auth.auth0user,
  getAllTokenLoading: state.auth.getAllTokenLoading,
  marqueeSplit: selectTreatmentWithConfig(state.splitio, 'bo_marquee_info'),
  topupSplit: selectTreatmentWithConfig(state.splitio, 'bo_topup_state'),
});

const mapDispatchToProps = {
  removeNavConfirm,
  initGetAllToken,
  auth0logout,
  initSplit,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DashboardPage));
